import React, { createContext, useState } from 'react'
import { IBreacrumbs } from '../components/Layout/breadcrumbs';

export interface IPageState {
  title:string;
  breadcrumbs: IBreacrumbs[];
  currentPage: string;
  path: string;
}

// const PAGEINFO = {
//   title: 'GMS',
//   breadcrumbs: [
//       FROM_STEPS.HOME, FROM_STEPS.INBOUND, FROM_STEPS.PVC_TO_PLANT, FROM_STEPS.SUMMARY
//   ],
//   currentStep: FROM_STEPS.INBOUND
// }

interface IPageContext {
  pageState:IPageState, setPageState: React.Dispatch<React.SetStateAction<IPageState>>
}

export const PageContext = createContext<IPageContext>({} as IPageContext)


const PageProvider = (props:any) => {

  const [pageState, setPageState] = useState<IPageState>({} as IPageState)

  React.useEffect(()=>{
  },[pageState])

  return (
    <PageContext.Provider value={{ pageState, setPageState }}>
      {props.children}
    </PageContext.Provider>
  )
}

export default PageProvider
